import { useState } from "react";

import { Column, DialogWrapper, TagTextAlert, Text, WalletButtons } from "@bridgesplit/ui";
import { useAppDialog } from "app/utils";
import { COPY } from "app/constants";
import { Wallet } from "@solana/wallet-adapter-react";
import { updateWallet, useAuthStorage } from "@bridgesplit/abf-react";
import { useDispatch } from "react-redux";
import { AppTracking, TrackEvent } from "app/types";

export default function ConnectDialog() {
    return (
        <DialogWrapper>
            <Verified />
        </DialogWrapper>
    );
}

function Verified() {
    const { close } = useAppDialog();
    const { resetCookies } = useAuthStorage();
    const dispatch = useDispatch();

    const [errorMessage, setErrorMessage] = useState<string>();

    return (
        <>
            <Column spacing={0.5} alignItems="center" textAlign="center">
                <Text variant="h3"> {COPY.CONNECT_PROMPT} </Text>
                <Text variant="body2" color="caption">
                    {COPY.CONNECT_DESCRIPTION}
                </Text>
            </Column>

            <WalletButtons
                trackingInfo={AppTracking.from(TrackEvent.SubmitWalletConnect)}
                onSelect={(wallet: Wallet) => {
                    // Manually reset cookies and set new user context
                    close();
                    resetCookies();

                    if (wallet.adapter.publicKey) {
                        const walletPublicKey = wallet.adapter.publicKey?.toString();
                        dispatch(updateWallet(walletPublicKey));
                    } else {
                        setErrorMessage("Unable to connnect");
                    }
                }}
            />

            {!!errorMessage && (
                <TagTextAlert color="error" icon="warning">
                    {errorMessage}
                </TagTextAlert>
            )}
        </>
    );
}
